import { CollectionParams, LiquidityPoolDetails, BuyWidgetParams, UserInfo, DisplayableOperation, SellWidgetParams, UserAddressParams, BuySellTransactionsParameters, BuySellTransactionsResponse, CashoutValidateResponse, CashoutResponse, CashoutTransactionsResponse, CashoutTransactionsParameters, CashoutTransactionDelegateParameters, CashoutRequest, TopUpLookUpParameters, TopUpLookUpResponse, getTopupProductsParameters, TopUpProduct, ProductPriceInfo, ProductPriceObject, getTopUpProviderStatus, getTopUpProviderResponse, getTopUpPromotionResponse, getTopUpPromotionParameters, TopUpCreateResponse, TopUpCreateRequestParameters, TopUpSendRequestParameters, TopUpsTransactionsParameters, TopUpsTransactionsResponse, UserEmailPhoneRegistrationResponse, EmailTokenRequestParameters, EmailTokenVerificationParameters, PhoneTokenRequestParameters, PhoneTokenVerificationParameters, UserRegistrationResponse, UserRegistrationParameters, UserRegistrationStatusRequestParameter, WalletKeysRegistrationParameters, WalletRegistrationResponse, apiRootResponse, WalletRecoveryPhoneRequestParameters, WalletRecoveryPhoneVerifyRequestParameters, WalletRecoveryRequestResponse, WalletKeyRecoveryParameters, EncryptedKey, WalletKeyRecoveryResponse, DocumentTransactionParameters, DocumentTransactionResponse, AccountStamentsParameters, AccountStatementsResponse, ContactsInPlatformResponse, BeneficiaryRequestParams, BeneficiaryResponse, WalletRecoveryEmailRequestParameters, WalletRecoveryEmailVerifyRequestParameters, BankTransferCreateRequestParams, BankTransferCreateResponse, BankTransferSendRequestParams, LaNavePromotionResponse, LaNaveUserValidateRequestParameters, LaNaveUserValidateResponse, LaNaveTopUpCreateRequestParameters, DelegateSigningParams, PaymentLinkRequest, PaymentLinkResponse, CreateWalletRequest, CreateWalletRequestResponse } from "../../../types/types";
import { createApi } from '@reduxjs/toolkit/query/react';

import { AxiosRequestConfig } from 'axios';
import { ebioroBaseQuery } from './';
import { StoreRequestParameters, StoresResponse } from "../../../types/stores";
import { BridgeKYCLinkRequestParams, BridgeKYCLinkResponse } from "./bridge";


interface UpdateUserCurrencyRequestParams {
    currency_code: string;
    id: string;
}

interface UpdateUserLocaleRequestParams {
    locale: string;
    id: string;
}

interface UpdateUserRequestNotificationParams {
    id: string;
    allowed: boolean;
}

interface InternalDepositParams {

    asset_code: string;
    account: string;

}

interface InternalSepaDepositResponse {
    recipient_name: string;
    iban_account: string;
    swift_bic: string;
}

interface CheckKeysMigrationSuccessResponse {
    has_keys: boolean;
    keys_migrated: boolean;
}

interface CheckKeysMigrationErrorResponse {
    error: string;
}

export type CheckKeysMigrationResponse = CheckKeysMigrationSuccessResponse | CheckKeysMigrationErrorResponse;

export type MarkKeysAsMigratedRequest = {
    email: string;
    public_key: string;
}

export type MarkKeysAsMigratedResponse = {
    message: string;
    migrated: boolean;
    public_key: string;
}

interface quotesParams {
    coins: string;
    authToken: string

}


export interface getAccountFieldsParams {
    bankCountry: string;
    currency: string;
}

export interface getCustomerTypeParams {
    type: string
}

export interface sep31BankTxParams {
    amount: string;
    asset_code: string;
    asset_issuer: string;
    sender_id: string;
    fields: {
        transaction: {
            details: string;
            full_name: string;
            account_number: string;
            country: string;
            type: string;
        };
    };
}
interface sep31BankTxResponse {
    id: '',
    stellar_account_id: '',
    stellar_memo: '',
    stellar_memo_type: '',
}

interface CompanyFedrationResponse {
    stellar_address: string;
    account_id: string;
    company_name: string;
}


export interface CompanyFedrationParams {
    q: string;
    type: string;
}

interface UserFedrationResponse {
    stellar_address: string;
    account_id: string;
    user_name?: string | undefined;
}

export interface UserFedrationParams {
    q: string;
    type: string;
}

enum AvailableAuthMethods {

    stellar_address = "stellar_address",
    phone_number = "phone_number",
    email = "email"
}

export const ebioroApi = createApi({
    reducerPath: "ebioro-api",
    baseQuery: ebioroBaseQuery,
    tagTypes: ['PendingSignature', 'UserInfo', 'Beneficiaries', 'BuySell', 'Cashout', 'TopUp', 'Statement', 'GiftCards', 'Payments', 'Stores'],
    endpoints: (builder) => ({

        getUserInfo: builder.query<UserInfo, any>({
            query: () => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/user`,
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['UserInfo'],
        }),

        getCountries: builder.query<any, void>({

            query: () => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/countries`,
                    method: 'get',
                }
                return axiosConfig;
            }

        }),

        addUserAddress: builder.mutation<UserInfo, UserAddressParams>({
            query: (params: UserAddressParams) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/address`,
                    method: "post",
                    data: {
                        user_id: params.user_id,
                        country_id: params.country_id,
                        address_1: params.address_1,
                        address_2: params.address_2,
                        city: params.city,
                        postal_code: params.postal_code,
                    },

                };
                return axiosConfig;
            },
            invalidatesTags: ['UserInfo'],
        }),

        updateUserDefaultCurrency: builder.mutation<UserInfo, UpdateUserCurrencyRequestParams>({

            query: (params) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/user/currency`,
                    data: {
                        currency_code: params.currency_code,
                        id: params.id
                    }
                };
                return axiosConfig;
            },
            invalidatesTags: ['UserInfo'],

        }),

        updateUserDefaultLanguage: builder.mutation<UserInfo, UpdateUserLocaleRequestParams>({

            query: (params) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/user/locale`,
                    data: {
                        locale: params.locale,
                        id: params.id
                    }
                };
                return axiosConfig;
            },
            invalidatesTags: ['UserInfo'],

        }),

        updateUser: builder.mutation<UserInfo, UpdateUserRequestNotificationParams>({

            query: (params) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/user/notification`,
                    data: {
                        id: params.id,
                        allowed: params.allowed
                    }
                };
                return axiosConfig;
            },
            invalidatesTags: ['UserInfo'],

        }),

        getQuotes: builder.query({
            query: (params: quotesParams) => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `/quotes`,
                    method: 'get',
                    params: { coins: params.coins }
                }
                return axiosConfig;
            },
        }),

        getQuote: builder.query({
            query: (coin: any) => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `/quotes/coin`,
                    method: 'get',
                    params: { coin: coin }
                }
                return axiosConfig;
            },
        }),

        isUser: builder.query({
            query: () => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/isUser`,
                };
                return axiosConfig;
            },
        }),

        delegateSigning: builder.mutation({

            query: (params: DelegateSigningParams) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/transactions/delegate`,
                    data: {
                        uri: params.uri,
                        account: params.account,
                        asset_code: params.asset_code,
                        msg: params.msg,
                        name: params.name,
                        fees: params.fees
                    }
                };
                return axiosConfig;
            },
            invalidatesTags: ['PendingSignature', 'Payments'],

        }),

        pendingSignatureTransactions: builder.query({

            query: (params) => {

                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/transactions/delegate/pending`,
                    params: params
                };
                return axiosConfig;
            },
            providesTags: ['PendingSignature'],

        }),

        delegateTransactionFee: builder.query<{ feeAccount: string, feePercentage: number }, {}>({

            query: () => {

                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/transactions/delegate/fees`,
                };
                return axiosConfig;
            },

        }),

        getKYCToken: builder.query({

            query: (levelName: string) => {

                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/kyc/kyc_token`,
                    params: {
                        levelName: levelName
                    },
                };

                return axiosConfig;
            },

        }),

        getBuyWidgetURL: builder.query({

            query: (params: BuyWidgetParams) => {

                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/buy/${params.provider}`,
                    params: {
                        asset_code: params.assetCode,
                        baseCurrencyCode: params.baseCurrencyCode,
                        baseCurrencyAmount: params.baseCurrencyAmount
                    }
                }

                return axiosConfig;
            },

        }),
        getSellWidgetURL: builder.query({

            query: (params: SellWidgetParams) => {

                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/sell/${params.provider}`,
                    params: {
                        asset_code: params.assetCode,
                        baseCurrencyCode: params.baseCurrencyCode,
                        baseCurrencyAmount: params.baseCurrencyAmount
                    }
                };

                return axiosConfig;
            },
        }),

        getOperations: builder.query<DisplayableOperation[], CollectionParams>({

            query: (params: CollectionParams = {}) => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/operations`,
                    method: 'get',
                    params: {
                        limit: params.limit,
                        cursor: params.cursor,
                    }
                }
                return axiosConfig;
            },

        }),

        getPayments: builder.query<DisplayableOperation[], CollectionParams>({

            query: (params: CollectionParams = {}) => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/payments`,
                    method: 'get',
                    params: {
                        limit: params.limit,
                        cursor: params.cursor,
                    }
                }
                return axiosConfig;
            },
            providesTags: ['Payments']
        }),

        getOperation: builder.query<any[], string>({

            query: (operationId) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/operation`,
                    params: {
                        operationId: operationId
                    },
                };

                return axiosConfig;
            },

        }),

        startInternalDeposit: builder.mutation<InternalSepaDepositResponse, InternalDepositParams>({
            query: (params) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/deposit`,
                    data: {
                        asset_code: params.asset_code,
                        account: params.account
                    }
                };
                return axiosConfig;
            },
        }),

        getBeneficiaries: builder.query<BeneficiaryResponse[], string>({

            query: (user_id) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/users/${user_id}/beneficiaries`,
                };

                return axiosConfig;
            },
            providesTags: ['Beneficiaries'],
        }),

        addBeneficiary: builder.mutation<{ id: string }, BeneficiaryRequestParams>({
            query: (params: BeneficiaryRequestParams) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/users/${params.user_id}/beneficiaries`,
                    data: params
                };
                return axiosConfig;
            },
            invalidatesTags: ['Beneficiaries'],
        }),

        updateBeneficiary: builder.mutation<BeneficiaryResponse, BeneficiaryRequestParams>({
            query: ({ id, user_id, ...rest }) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "put",
                    url: `/wallet/users/${user_id}/beneficiaries/${id}`,
                    data: rest
                };
                return axiosConfig;
            },
            invalidatesTags: ['Beneficiaries'],
        }),

        deleteBeneficiary: builder.mutation<any, BeneficiaryRequestParams>({
            query: ({ id, user_id }) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: 'DELETE',
                    url: `/wallet/users/${user_id}/beneficiaries/${id}`,
                };
                return axiosConfig;
            },
            invalidatesTags: ['Beneficiaries'],
        }),

        getCountryList: builder.query<any, void>({
            query: () => ({
                url: `/wallet/beneficiaries/countries`,
                method: 'GET',
            })
        }),
        getCurrencyBySelectedCountry: builder.query<any, string>({
            query: (bankCountry: string) => ({
                url: `/wallet/beneficiaries/currencies?bankCountry=${bankCountry}`,
                method: 'GET',
            })
        }),
        getAccountFields: builder.query<any, getAccountFieldsParams>({
            query: (params) => ({
                url: `/wallet/beneficiaries/account-fields?bankCountry=${params.bankCountry}&currency=${params.currency}`,
                method: 'GET',
            }),
        }),
        getPools: builder.query<LiquidityPoolDetails[], undefined>({

            query: () => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/pools`,
                };

                return axiosConfig;
            },

        }),
        getPool: builder.query<LiquidityPoolDetails, string>({
            query: (id) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/pools/${id}`,
                };

                return axiosConfig;
            },

        }),
        getSep31Info: builder.query<any, void>({
            query: (id) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `sep31/info`,
                };

                return axiosConfig;
            },

        }),
        // getCustomerInfo: builder.query<any, getCustomerTypeParams>({
        //     query: (getCustomerTypeParams) => ({
        //       url: `sep12/customer`,
        //       method: 'GET',
        //       params: {
        //         type: getCustomerTypeParams.type,
        //       },
        //     }),
        //   }),
        // createBankTx: builder.mutation<sep31BankTxResponse,sep31BankTxParams>({
        //     query: (params:any) => {
        //         const axiosConfig: AxiosRequestConfig = {
        //             method: "post",
        //             url: `sep31/transactions`,
        //             data: {
        //                 amount: params.amount,
        //                 asset_code: params.asset_code,
        //                 asset_issuer: params.asset_issuer,
        //                 sender_id: params.sender_id,
        //                 fields: {
        //                   transaction: {
        //                     details: params.fields.transaction.details,
        //                     full_name: params.fields.transaction.full_name,
        //                     account_number: params.fields.transaction.account_number,
        //                     country: params.fields.transaction.country,
        //                     type: params.fields.transaction.type,
        //                   },
        //                 },
        //               },
        //         };
        //         return axiosConfig;
        //     },
        // }),
        // companyFederation: builder.query<CompanyFedrationResponse,CompanyFedrationParams>({
        //     query: (params: CompanyFedrationParams ) => {

        //         const axiosConfig: AxiosRequestConfig = {
        //             url:`wallet/companyFederation`,
        //             method:'get',
        //             params:{
        //                 q: params.q,
        //                 type: params.type,
        //             }
        //         }
        //         return axiosConfig;
        //     },
        // }),
        userFederation: builder.query<UserFedrationResponse, UserFedrationParams>({
            query: (params: UserFedrationParams) => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `wallet/federation`,
                    method: 'get',
                    params: {
                        q: params.q,
                        type: params.type,
                    }
                }
                return axiosConfig;
            },
        }),
        apiRoot: builder.query<apiRootResponse, any>({
            query: () => {

                const axiosConfig: AxiosRequestConfig = {
                    url: `ip`,
                    method: 'get'
                }
                return axiosConfig;
            },
        }),
        getTransaction: builder.query<any, string>({
            query: (txId: string) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `wallet/transactions/${txId}`,
                    method: 'get'
                }
                return axiosConfig;
            },
        }),
        getWalletUsers: builder.query<any[], string>({
            query: (value: string) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/users`,
                    params: {
                        value: value
                    },
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        getWalletUser: builder.query<any, string>({
            query: (value: string) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/wallet_user`,
                    params: {
                        value: value
                    },
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        getBuySellTransactions: builder.query<BuySellTransactionsResponse, BuySellTransactionsParameters>({
            query: (params: BuySellTransactionsParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/buy-sell/transactions`,
                    params: params,
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['BuySell'],
        }),
        cashoutValidate: builder.query<CashoutValidateResponse, void>({
            query: () => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "get",
                    url: `/wallet/cashout/validate`,
                };
                return axiosConfig;
            },
        }),
        cashout: builder.mutation<CashoutResponse, CashoutRequest>({
            query: (params: CashoutRequest) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/cashout/deposit`,
                    data: {
                        amount: params.amount,
                        asset_code: params.asset_code
                    }
                };
                return axiosConfig;
            },
        }),

        getAccountStaments: builder.query<AccountStatementsResponse, AccountStamentsParameters>({
            query: (params: AccountStamentsParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/effect/${params.user_id}`,
                    params: {
                        page: params.page,
                        limit: params.limit
                    },
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['Statement'],
        }),

        generateAccountStatement: builder.mutation<DocumentTransactionResponse, DocumentTransactionParameters>({

            query: (params: DocumentTransactionParameters) => {

                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/effect`,
                    data: {
                        asset_code: params.asset_code,
                        start_date: params.start_date,
                        end_date: params.end_date
                    }
                };

                return axiosConfig;
            },
            invalidatesTags: ['Statement'],
        }),

        deleteAccountStatement: builder.mutation<any, any>({
            query: ({ id }) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: 'DELETE',
                    url: `/wallet/effect/${id}`,
                };
                return axiosConfig;
            },
            invalidatesTags: ['Statement'],
        }),

        getCashoutTransactions: builder.query<CashoutTransactionsResponse, CashoutTransactionsParameters>({
            query: (params: CashoutTransactionsParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/cashout/transactions`,
                    params: params,
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['Cashout'],
        }),
        cashOutdelegateSigning: builder.mutation({

            query: (params: CashoutTransactionDelegateParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/cashout/transactions/delegate`,
                    data: {
                        id: params.id,
                        uri: params.uri,
                        account: params.account,
                        asset_code: params.asset_code,

                    }
                };
                return axiosConfig;
            },
            invalidatesTags: ['Cashout'],

        }),
        getCashoutTransaction: builder.query<any, string>({
            query: (txId: string) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet/cashout/transactions/${txId}`,
                    method: 'get'
                }
                return axiosConfig;
            },
        }),
        getToUpLookUp: builder.query<TopUpLookUpResponse, TopUpLookUpParameters>({
            query: (accountNumber: TopUpLookUpParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/lookup`,
                    method: 'get',
                    params: {
                        accountNumber: accountNumber.accountNumber
                    }
                }
                return axiosConfig;
            },
            transformResponse: (data: TopUpLookUpResponse) => {
                //let response:TopUpLookUpResponse;

                data.providers.map((item) => {
                    item.processing_transfers = true;
                    //response.push(item);
                })
                return data
            }
        }),
        getToUpProducts: builder.query<TopUpProduct[], getTopupProductsParameters>({
            query: (params: getTopupProductsParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/products`,
                    method: 'get',
                    params: {
                        provider_code: params.provider_code,
                        region_code: params.region_code
                    }
                }
                return axiosConfig;
            },
        }),
        topupEstimatePrices: builder.mutation<ProductPriceObject[], any[]>({
            query: (data: any) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/topups/prices`,
                    data: data
                };
                return axiosConfig;
            },
        }),
        getToUpProviderStatus: builder.query<getTopUpProviderResponse, getTopUpProviderStatus>({
            query: (params: getTopUpProviderStatus) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/providers/status`,
                    method: 'get',
                    params: {
                        provider_codes: params.provider_codes,
                    }
                }
                return axiosConfig;
            },
        }),

        getToUpPromotions: builder.query<getTopUpPromotionResponse[], getTopUpPromotionParameters>({
            query: (params: getTopUpPromotionParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/promotions`,
                    method: 'get',
                    params: {
                        provider_code: params.provider_code,
                        currency_iso: params.currency_iso
                    }
                }
                return axiosConfig;
            },
        }),

        topupSendCreate: builder.mutation<TopUpCreateResponse, TopUpCreateRequestParameters>({
            query: (params: TopUpCreateRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/topups/transfer/create`,
                    data: params
                };
                return axiosConfig;
            },
        }),

        topupSend: builder.mutation<any, TopUpSendRequestParameters>({
            query: (data: TopUpSendRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/topups/transfer/delegate`,
                    data: data
                };
                return axiosConfig;
            },
        }),

        getTopUpTransactions: builder.query<TopUpsTransactionsResponse, TopUpsTransactionsParameters>({
            query: (params: TopUpsTransactionsParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/transactions`,
                    params: params,
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['TopUp'],
        }),

        getEmailVerificationToken: builder.query<UserEmailPhoneRegistrationResponse, EmailTokenRequestParameters>({
            query: (params: EmailTokenRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/registration/users/email/token`,
                    params: params,
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        /** Requests with headers will omit the default headers set by the ebioroBaseQuery */
        verifyEmailToken: builder.mutation<UserEmailPhoneRegistrationResponse, EmailTokenVerificationParameters>({
            query: (params: EmailTokenVerificationParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    method: "post",
                    url: `/registration/users/email/token/verify`,
                    data:
                    {
                        email: params.email,
                        tokenId: params.tokenId,
                        code: params.code
                    }
                };
                return axiosConfig;
            },
        }),

        getPhoneVerificationToken: builder.query<UserEmailPhoneRegistrationResponse, PhoneTokenRequestParameters>({
            query: (params: PhoneTokenRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    url: `/registration/users/phone/token`,
                    params: { email: params.email, mobile: params.mobile },
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        verifyPhoneToken: builder.mutation<UserEmailPhoneRegistrationResponse, PhoneTokenVerificationParameters>({
            query: (params: PhoneTokenVerificationParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    method: "post",
                    url: `/registration/users/phone/token/verify`,
                    data: {
                        tokenId: params.tokenId,
                        email: params.email,
                        code: params.code,
                        mobile: params.mobile
                    }
                };
                return axiosConfig;
            },
        }),

        getAccountRecoveryPartialToken: builder.query<{ partial_token: string }, { email: string, auth_token: string }>({
            query: (params: { email: string, auth_token: string }) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    url: `/registration/users/account-recovery/token`,
                    params: { email: params.email },
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        registerUser: builder.mutation<UserRegistrationResponse, UserRegistrationParameters>({
            query: (params: UserRegistrationParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    method: "post",
                    url: `/registration/users`,
                    data: {
                        first_name: params.first_name,
                        last_name: params.last_name,
                        email: params.email,
                        is_email_verified: params.is_email_verified,
                        mobile_number: params.mobile_number,
                        is_mobile_number_verified: params.is_mobile_number_verified,
                        calling_code: params.calling_code,
                        stellar_account: params.stellar_account,
                        txEnvelope: params.txEnvelope
                    }
                };
                return axiosConfig;
            },
        }),

        getUserRegistrationStatus: builder.query<UserRegistrationResponse, UserRegistrationStatusRequestParameter>({
            query: (params: UserRegistrationStatusRequestParameter) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/registration/users/${params.id}`,
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        recoverWalletByPhone: builder.query<WalletRecoveryRequestResponse, WalletRecoveryPhoneRequestParameters>({
            query: (params: WalletRecoveryPhoneRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet-recovery/phone/token`,
                    method: 'get',
                    params: params
                }
                return axiosConfig;
            },
        }),
        recoverWalletByPhoneVerify: builder.mutation<WalletRecoveryRequestResponse, WalletRecoveryPhoneVerifyRequestParameters>({
            query: (params: WalletRecoveryPhoneVerifyRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    method: "post",
                    url: `/wallet-recovery/phone/token/verify`,
                    data: {
                        tokenId: params.tokenId,
                        code: params.code,
                        mobile: params.mobile
                    }
                };
                return axiosConfig;
            },
        }),

        recoverWalletByEmail: builder.query<WalletRecoveryRequestResponse, WalletRecoveryEmailRequestParameters>({
            query: (params: WalletRecoveryEmailRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet-recovery/email/token/login`,
                    method: 'get',
                    params: params
                }
                return axiosConfig;
            },
        }),

        recoverWalletByEmailVerify: builder.mutation<WalletRecoveryRequestResponse, WalletRecoveryEmailVerifyRequestParameters>({
            query: (params: WalletRecoveryEmailVerifyRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    method: "post",
                    url: `/wallet-recovery/email/token/verify`,
                    data: {
                        tokenId: params.tokenId,
                        code: params.code,
                        email: params.email
                    }
                };
                return axiosConfig;
            },
        }),

        getWalletEncryptedKeys: builder.query<EncryptedKey[] | null, WalletKeyRecoveryParameters>({
            query: (params: WalletKeyRecoveryParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/wallet-recovery/keys`,
                    headers: { Authorization: 'Bearer ' + `${params.auth_token}` },
                    method: 'get'

                }
                return axiosConfig;
            },
        }),

        getGiftCardTransactions: builder.query<TopUpsTransactionsResponse, TopUpsTransactionsParameters>({
            query: (params: TopUpsTransactionsParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/transactions/giftcards`,
                    params: params,
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['GiftCards'],
        }),

        getGiftCards: builder.query({
            query: () => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/topups/products/giftcards`,
                    method: 'get'
                }
                return axiosConfig;
            },
        }),

        giftCardSendCreate: builder.mutation<TopUpCreateResponse, TopUpCreateRequestParameters>({
            query: (params: TopUpCreateRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/topups/transfer/giftcard/create`,
                    data: params
                };
                return axiosConfig;
            },
        }),

        contactsInPlatform: builder.mutation<ContactsInPlatformResponse[], any[]>({
            query: (params: any[]) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/wallet/recipients/contacts/phone`,
                    data: {
                        contacts: params
                    }
                };
                return axiosConfig;
            },
        }),

        getBankTransferFee: builder.query<{ fee: number }, { amount: number }>({
            query: (params: { amount: number }) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/bank-transfer/transfers/fee`,
                    method: 'get',
                    params: { amount: params.amount }
                }
                return axiosConfig;
            },
        }),

        bankTransferCreate: builder.mutation<BankTransferCreateResponse, BankTransferCreateRequestParams>({
            query: (params: BankTransferCreateRequestParams) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/bank-transfer/transfers/create`,
                    data: params
                };
                return axiosConfig;
            },
        }),

        bankTransferSend: builder.mutation<any, BankTransferSendRequestParams>({
            query: (data: BankTransferSendRequestParams) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/bank-transfer/transfers/delegate`,
                    data: data
                };
                return axiosConfig;
            },
        }),

        getLaNavePromotions: builder.query<LaNavePromotionResponse[], undefined>({
            query: () => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/lanave/promotions`,
                    method: 'get',
                }
                return axiosConfig;
            },
            transformResponse: (promotions: LaNavePromotionResponse[]) => {

                const sortedData = promotions.sort(function (a, b) {

                    if (a.usd_currency_amount > b.usd_currency_amount) { return 1; }
                    if (a.usd_currency_amount < b.usd_currency_amount) { return -1; }
                    return 0;
                });


                return sortedData
            }
        }),

        validateLaNaveUser: builder.mutation<LaNaveUserValidateResponse, LaNaveUserValidateRequestParameters>({
            query: (data: LaNaveUserValidateRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/lanave/validate/role`,
                    data: data
                };
                return axiosConfig;
            },
        }),

        topupLaNaveSendCreate: builder.mutation<TopUpCreateResponse, LaNaveTopUpCreateRequestParameters>({
            query: (params: LaNaveTopUpCreateRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/lanave/transfer/create`,
                    data: params
                };
                return axiosConfig;
            },
        }),
        topupLaNaveSend: builder.mutation<any, TopUpSendRequestParameters>({
            query: (data: TopUpSendRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/lanave/transfer/delegate`,
                    data: data
                };
                return axiosConfig;
            },
        }),

        signUri: builder.mutation<{ uri: string }, { uri: string }>({
            query: (data: { uri: string }) => {
                const axiosConfig: AxiosRequestConfig = {
                    method: "post",
                    url: `/payme/sign`,
                    data: data
                };
                return axiosConfig;
            },
        }),

        getPaymentLink: builder.query<PaymentLinkResponse, PaymentLinkRequest>({
            query: (params: PaymentLinkRequest) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/payme`,
                    method: 'get',
                    params: {
                        amount: params.amount,
                        asset_code: params.asset_code,
                        asset_issuer: params.asset_issuer,
                        msg: params.message
                    }
                }
                return axiosConfig;
            },
        }),

        getStores: builder.query<StoresResponse, StoreRequestParameters>({
            query: (params: StoreRequestParameters) => {
                const axiosConfig: AxiosRequestConfig = {
                    url: `/stores`,
                    params: {
                        page: params.page,
                        limit: params.limit
                    },
                    method: 'get'
                }
                return axiosConfig;
            },
            providesTags: ['Stores'],
        }),

        getStoreLink: builder.query<{ url: string }, { storeId: string; userId: string }>({
            query: ({ storeId, userId }) => ({
                url: `/stores/${storeId}/link`,
                method: 'GET',
                params: { userId },
            }),
        }),

        // Virtual Accounts (Bridge) — create KYC/TOS links
        createVirtualAccountsKycLink: builder.mutation<
            BridgeKYCLinkResponse,
            BridgeKYCLinkRequestParams
        >({
            query: (body) => ({
                url: `/virtual-accounts/kyc-link`,
                method: 'POST',
                data: body,
            }),
        }),

        refreshVirtualAccountsKycLink: builder.query<
            BridgeKYCLinkResponse,
            { linkId: string }
        >({
            query: ({ linkId }) => ({
                url: `/virtual-accounts/kyc-links/${linkId}/refresh`,
                method: 'GET',
            }),
        }),

        getVirtualAccounts: builder.query<any[], { userId: string }>({
            query: ({ userId }) => ({
                url: `/virtual-accounts`,
                method: 'GET',
                params: { userId },
            }),
        }),

        createWallet: builder.mutation<CreateWalletRequestResponse, CreateWalletRequest>({
            query: (body: CreateWalletRequest) => ({
                url: `/wallet/create`,
                method: 'POST',
                data: body,
            }),
        }),

        checkKeysMigration: builder.query<
            CheckKeysMigrationSuccessResponse,
            { email: string }
        >({
            query: ({ email }) => ({
                url: `/wallet-recovery/has-keys`,
                method: 'GET',
                params: {
                    email: email
                }
            }),
            // transformResponse: (response: any, meta: any): CheckKeysMigrationSuccessResponse => {
            //     // Always return the success response structure
            //     return {
            //         has_keys: response.has_keys,
            //         keys_migrated: response.keys_migrated
            //     };
            // },
            // transformErrorResponse: (response: any, meta: any) => {
            //     console.log('Error transform response:', response);
            //     // Handle error response (404 status code)
            //     if (meta?.response?.status === 404 && response.data?.error) {
            //         return {
            //             error: response.data.error,
            //             status: 404
            //         };
            //     }
            //     // Handle other error cases
            //     return {
            //         error: response.data?.error || 'Unknown error occurred',
            //         status: meta?.response?.status || 500
            //     };
            // }
        }),


        markKeysAsMigrated: builder.mutation<MarkKeysAsMigratedResponse, MarkKeysAsMigratedRequest>({
            query: (body: MarkKeysAsMigratedRequest) => ({
                url: `/wallet-recovery/mark-keys-migrated`,
                method: 'POST',
                data: body,
            }),

        })
    })
})

export const {
        useGetUserInfoQuery,
        useGetQuotesQuery,
        useIsUserQuery,
        useGetQuoteQuery,
        useDelegateSigningMutation,
        usePendingSignatureTransactionsQuery,
        useDelegateTransactionFeeQuery,
        useGetKYCTokenQuery,
        useGetBuyWidgetURLQuery,
        useGetOperationsQuery,
        useGetPaymentsQuery,
        useGetOperationQuery,
        useUpdateUserDefaultCurrencyMutation,
        useUpdateUserMutation,
        useStartInternalDepositMutation,
        useGetBeneficiariesQuery,
        useGetPoolsQuery,
        useGetPoolQuery,
        useAddBeneficiaryMutation,
        useUpdateBeneficiaryMutation,
        useDeleteBeneficiaryMutation,
        useGetCountryListQuery,
        useGetCurrencyBySelectedCountryQuery,
        useGetAccountFieldsQuery,
        useGetSep31InfoQuery,
        useUserFederationQuery,
        useGetWalletUsersQuery,
        useApiRootQuery,
        useGetCountriesQuery,
        useAddUserAddressMutation,
        useGetBuySellTransactionsQuery,
        useCashoutMutation,
        useCashoutValidateQuery,
        useGetCashoutTransactionsQuery,
        useGetCashoutTransactionQuery,
        useCashOutdelegateSigningMutation,
        useGetToUpLookUpQuery,
        useGetToUpProductsQuery,
        useTopupEstimatePricesMutation,
        useGetToUpProviderStatusQuery,
        useGetToUpPromotionsQuery,
        useTopupSendCreateMutation,
        useTopupSendMutation,
        useGetTopUpTransactionsQuery,
        useGetEmailVerificationTokenQuery,
        useGetPhoneVerificationTokenQuery,
        useVerifyEmailTokenMutation,
        useVerifyPhoneTokenMutation,
        useGetAccountRecoveryPartialTokenQuery,
        useRegisterUserMutation,
        useGetUserRegistrationStatusQuery,
        useRecoverWalletByPhoneQuery,
        useRecoverWalletByPhoneVerifyMutation,
        useRecoverWalletByEmailQuery,
        useRecoverWalletByEmailVerifyMutation,
        useGetWalletEncryptedKeysQuery,
        useGenerateAccountStatementMutation,
        useGetAccountStamentsQuery,
        useGetGiftCardTransactionsQuery,
        useGetGiftCardsQuery,
        useGiftCardSendCreateMutation,
        useUpdateUserDefaultLanguageMutation,
        useContactsInPlatformMutation,
        useGetWalletUserQuery,
        useGetBankTransferFeeQuery,
        useBankTransferCreateMutation,
        useBankTransferSendMutation,
        useDeleteAccountStatementMutation,
        useGetLaNavePromotionsQuery,
        useValidateLaNaveUserMutation,
        useTopupLaNaveSendCreateMutation,
        useTopupLaNaveSendMutation,
        useSignUriMutation,
        useGetPaymentLinkQuery,
        useGetStoresQuery,
        useGetStoreLinkQuery,
        useLazyGetStoreLinkQuery,
        useCreateVirtualAccountsKycLinkMutation,
        useGetVirtualAccountsQuery,
        useRefreshVirtualAccountsKycLinkQuery,
        useCreateWalletMutation,
        useCheckKeysMigrationQuery,
        useMarkKeysAsMigratedMutation
} = ebioroApi



